import { type Ref, ref } from 'vue';

interface LegacyDescriptor extends PropertyDescriptor {
  initializer?: (this: object) => unknown;
}

type RefHost = Record<string, Ref<unknown> | undefined>;

export function reactive(
  _target: object,
  propertyKey: string,
  descriptor?: LegacyDescriptor
): PropertyDescriptor {
  const refProp = `_${propertyKey}Ref`;

  function createRef(
    instance: RefHost,
    hasExplicit: boolean,
    explicitValue?: unknown
  ): void {
    const initialValue = hasExplicit
      ? explicitValue
      : descriptor?.initializer
        ? descriptor.initializer.call(instance)
        : null;
    instance[refProp] = ref<unknown>(initialValue);
  }

  return {
    enumerable: true,
    configurable: true,
    get(this: RefHost) {
      if (!this[refProp]) createRef(this, false);
      return this[refProp]?.value;
    },
    set(this: RefHost, value: unknown) {
      const existing = this[refProp];
      if (existing) {
        existing.value = value;
      } else {
        createRef(this, true, value);
      }
    },
  };
}
